module.exports = __webpack_public_path__ + "img/food.03f6b6cc.png";